export const FRONT_BASE_URL = "http://ngo.gov.sy/";
// export const BACK_BASE_URL = "https://dev.back.test.ngo-platform.com/api";
// export const BACK_BASE_URL = "https://dev.back.ngo.warshatec.com/api";
// export const BACK_BASE_URL = "https://back.ngo-platform.com/api";
// export const BACK_BASE_URL ="http://185.216.132.174/api";
// export const BACK_BASE_URL = "http://192.168.1.100:8000/api";
// export const BACK_BASE_URL = "https://d880-95-159-1-255.ngrok-free.app/api";
// export const BACK_BASE_URL = "http://192.168.0.103:8080/api";
export const BACK_BASE_URL = "http://backend.ngo.gov.sy/api";
